import { firebaseAction } from "vuexfire";
import weather from "../util/weather";
import firebase from "firebase/app";
import constants from "../config/constants";

export default {
  namespaced: true,
  state: {
    list: [],
    current: {},
    currentTariff: [],
  },
  getters: {},
  mutations: {
    setCurrent: function (state, installation) {
      state.current = installation;
    },

    setWeather: function (state, payload) {
      state.list[payload.index].weather = payload.weather;
    },

    setCurrentWeather: function (state, weather) {
      state.current.weather = weather;
    },

    setCurrentTariff: function (state, tariff) {
      state.currentTariff = tariff;
    },
  },
  actions: {
    //BINDINGS

    setList: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve) => {
        bindFirebaseRef("list", ref, {
          readyCallback() {
            resolve();
          },
        });
      });
    }),

    bindCurrent: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve) => {
        bindFirebaseRef("current", ref, {
          readyCallback() {
            resolve();
          },
          errorCallback(error) {
            console.log(error);
          },
        });
      });
    }),

    bindCurrentTariff: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve) => {
        bindFirebaseRef("currentTariff", ref, {
          readyCallback() {
            resolve();
          },
        });
      });
    }),

    setCurrent: function (context, id) {
      return new Promise((resolve, reject) => {
        let installation = context.state.list.find(
          (installation) => installation[".key"] === id
        );
        if (!installation) reject();
        context.dispatch(
          "bindCurrent",
          firebase.database().ref("/installations2").child(id)
        );
        firebase
          .database()
          .ref("kwh_tariff")
          .child(id)
          .once("value", (tariff) => {
            let installationTariff =
              tariff.val() !== null ? tariff.val() : constants.defaultTariff;
            context.commit("setCurrentTariff", installationTariff);
          })
          .then(() => {
            resolve();
          });
      });
    },

    setInstallationsWeather(context) {
      return new Promise((resolve) => {
        const promises = [];
        context.state.list.forEach((installation, index) => {
          const promise = weather
            .getByInstallation(installation)
            .then((weather) => {
              context.commit("setWeather", { index: index, weather: weather });
            });
          promises.push(promise);
        });
        Promise.all(promises).then(() => resolve());
      });
    },

    setCurrentWeather(context) {
      return new Promise((resolve) => {
        weather.getByInstallation(context.state.current).then((weather) => {
          context.commit("setCurrentWeather", weather);
          resolve();
        });
      });
    },

    //WIZARD
    createInstallation: function (context, form) {
      return new Promise((resolve) => {
        let payload = form;
        let id = firebase.database().ref().push().key;

        payload.power = false;
        payload.userid = context.rootState.user.current.uid;
        payload.cost_limit = 0;

        firebase
          .database()
          .ref("installations2")
          .child(id)
          .set(payload)
          .then(() => {
            firebase
              .database()
              .ref("kwh_tariff")
              .child(id)
              .set(constants.defaultTariff)
              .then(() => resolve(id));
          });
      });
    },

    updateInstallation: function (context, { installation, form }) {
      //UPDATE DEVICES OFFSET

      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      Object.values(installation.zones).forEach((zone) => {
        getDevices(zone);
      });

      devices.forEach((device) => {
        context.dispatch(
          "devices/update",
          {
            device: { serialnumber: device },
            payload: { gmt: installation.timeZone },
          },
          { root: true }
        );
      });

      return firebase
        .database()
        .ref("/installations2")
        .child(installation[".key"])
        .update(form);
    },

    uploadImage: function (context, { installation, file }) {
      return new Promise((resolve) => {
        if (
          installation.image_path !== undefined &&
          installation.image_path.length > 0
        ) {
          let deleteRef = firebase
            .storage()
            .ref(context.rootState.user.current.uid)
            .child("installation-images")
            .child(installation.image_path);
          deleteRef.delete();
        }

        let imageName =
          installation[".key"] + "-" + Math.floor(Date.now() / 1000);
        let ref = firebase
          .storage()
          .ref(context.rootState.user.current.uid)
          .child("installation-images")
          .child(imageName);

        ref.put(file).then(() => {
          firebase
            .database()
            .ref("/installations2")
            .child(installation[".key"])
            .update({ image_path: imageName })
            .then(() => {
              resolve();
            });
        });
      });
    },

    //THERMOSTAT

    setPower(context, { installation, power }) {
      firebase
        .database()
        .ref("installations2")
        .child(installation[".key"])
        .update({ power: power });
      //UPDATE CHILDREN
      if (installation.zones !== undefined) {
        Object.values(installation.zones).forEach((zone) => {
          context.dispatch(
            "zones/setPower",
            {
              zone: zone,
              power: power,
              discardAcs: true,
              installationId: installation[".key"],
            },
            { root: true }
          );
        });
      }
    },

    setTemperature(context, { installation, temperature }) {
      //UPDATE CHILDREN
      if (installation.zones !== undefined) {
        Object.values(installation.zones).forEach((zone) => {
          context.dispatch(
            "zones/setTemperature",
            {
              zone: zone,
              temperature: temperature,
              discardAcs: true,
            },
            { root: true }
          );
        });
      }
    },

    setMode(context, { installation, mode }) {
      //UPDATE CHILDREN
      if (installation.zones !== undefined) {
        Object.values(installation.zones).forEach((zone) => {
          context.dispatch(
            "zones/setMode",
            {
              zone: zone,
              mode: mode,
              discardAcs: true,
            },
            { root: true }
          );
        });
      }
    },

    async getInstallationThermostatMode(context, { installation }) {
      if (installation.zones !== undefined) {
        let devices = [];

        for (const zone of Object.values(installation.zones)) {
          if (zone.zones !== undefined) {
            for (const z of Object.values(zone.zones)) {
              // get devices
              const subzoneDevices = await context.dispatch(
                "zones/getZoneDevices",
                { zone: z },
                { root: true }
              );
              devices = devices.concat(subzoneDevices);
            }
          }

          const zoneDevices = await context.dispatch(
            "zones/getZoneDevices",
            { zone: zone },
            { root: true }
          );
          devices = devices.concat(zoneDevices);
        }

        // remove undefined from devices array
        const filteredDevices = devices.filter(Boolean);

        const manual = filteredDevices.every((device) => {
          return device.data.mode === constants.modes.manual;
        });

        const auto = filteredDevices.every((device) => {
          return device.data.mode === constants.modes.auto;
        });

        if (manual === true) return false;
        else if (auto === true) return true;
        else return null;
      }

      return null;
    },

    //TARIFF
    updateTariff(context, { installation, form }) {
      return new Promise((resolve) => {
        //UPDATE TARIFF
        firebase
          .database()
          .ref("kwh_tariff")
          .child(installation[".key"])
          .update(form.tariff);

        let payload = {
          currency: form.currency,
          cost_limit: form.cost_limit,
        };

        context.dispatch("updateInstallation", {
          installation: installation,
          form: payload,
        });
        resolve();
      });
    },

    updateCost(context, { installation, cost }) {
      context.dispatch("updateInstallation", {
        installation: installation,
        form: { cost_limit: cost },
      });
    },

    //STATISTICS

    setStatistics(context, payload) {
      //GET DEVICES
      let installation = context.state.current;
      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      Object.values(installation.zones).forEach((zone) => {
        getDevices(zone);
      });

      //ACTION ON STATISTICS WITH DEVICES AND DATE
      return context.dispatch(
        "statistics/setData",
        { filters: payload, devices: devices, discardAcs: true },
        { root: true }
      );
    },

    setQuickSense(context) {
      //GET DEVICES
      let installation = context.state.current;
      let devices = [];

      function getDevices(zone) {
        if (
          zone.zones === undefined &&
          zone.final &&
          zone.devices !== undefined
        ) {
          //ADD DEVICES
          Object.keys(zone.devices).forEach((device) => {
            devices.push(device);
          });
        }
        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getDevices(z));
      }

      Object.values(installation.zones).forEach((zone) => {
        getDevices(zone);
      });

      //ACTION ON STATISTICS WITH DEVICES AND DATE
      return context.dispatch(
        "statistics/setQuickSense",
        {
          devices: devices,
          installation: installation,
        },
        { root: true }
      );
    },
  },
};
